
<template>
    <div>
        <mars-view class="bg-color"><top-bar :title="topBar.title" :bg-color="topBar.topBgColor" :text-color="topBar.fontColor" @handleBack="handleBack"></top-bar><mars-view class="wrapper"><mars-view class="top"><mars-view class="title l-font-semibold"><mars-text class="icon iconfont success"></mars-text>预约派发成功
            </mars-view><mars-view class="sub l-font-regular">
                您的预约已成功发布，请耐心等待律师致电
            </mars-view><mars-view class="info"><mars-view class="info-title l-font-regular"><mars-image class="info-title-image" src="https://lvlin-midplat.cdn.bcebos.com/prosecute/prosecute-success.png"></mars-image>
                    预约详情
                </mars-view><mars-view class="line"></mars-view><mars-view class="info-item"><mars-view class="left">预约服务</mars-view><mars-view class="right">{{ entrustedValue.serviceName }}</mars-view></mars-view><mars-view class="info-item"><mars-view class="left">律师地区</mars-view><mars-view class="right">{{ entrustedValue.city }}</mars-view></mars-view><mars-view class="info-item"><mars-view class="left">发布时间</mars-view><mars-view class="right">{{ entrustedValue.submitTime }}</mars-view></mars-view><mars-view class="info-item"><mars-view class="left">案件描述</mars-view><mars-view class="right">{{ entrustedValue.consultContent }}</mars-view></mars-view></mars-view><mars-view class="tip">
                您可以通过以下方式查看您的预约信息:
                <mars-image class="tip-img" mode="widthFix" src="https://lvlin-midplat.cdn.bcebos.com/prosecute-process-new.png"></mars-image></mars-view></mars-view></mars-view></mars-view>
    </div>
</template>

<script>
import Topbar from "../../components/common/topbar.vue";
export default {
  components: {
    'top-bar': Topbar
  },
  created() {
    this.entrustedValue = JSON.parse(this.$api.getStorageSync('entrustedValue') || '{}');
    (function () {
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  data() {
    return {
      topBar: {
        fontColor: '#fff',
        title: '',
        topBgColor: '#336cff'
      },
      entrustedValue: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.bg-color {
  padding-top: 200px;
  margin-top: -200px;
  background-image: linear-gradient(180deg, #336cff 0%, #336cff 100%);
}
.wrapper {
  width: 100%;
}
.wrapper .top {
  height: 2.34rem;
  background: #336cff;
  background-image: linear-gradient(180deg, #336cff 0%, #336cff 80%, #f8f8f8 100%);
}
.wrapper .top .title {
  font-size: 0.22rem;
  color: #fff;
  line-height: 0.27rem;
  font-weight: 600;
  text-align: center;
}
.wrapper .top .title .success {
  font-size: 0.22rem;
  margin-right: 0.07rem;
}
.wrapper .top .sub {
  font-size: 0.14rem;
  color: #fff;
  line-height: 0.14rem;
  text-align: center;
  margin: 0.15rem 0 0.3rem;
}
.wrapper .top .info {
  width: calc(100% - 20px);
  background: #fff;
  border-radius: 0.12rem;
  margin: 0 auto;
  padding: 0.12rem 0.13rem 0.02rem;
  box-sizing: border-box;
}
.wrapper .top .info-title {
  display: flex;
  font-size: 0.16rem;
  color: #1f1f1f;
  line-height: 0.26rem;
}
.wrapper .top .info-title .info-title-image {
  width: 0.24rem;
  height: 0.24rem;
  border-radius: 50%;
  margin-right: 0.06rem;
}
.wrapper .top .info .line {
  margin: 0.12rem 0 0.12rem;
  border-bottom: 0.66px solid #eee;
}
.wrapper .top .info .info-item {
  width: 100%;
  font-size: 0.15rem;
  line-height: 0.25rem;
  display: flex;
  margin-bottom: 0.06rem;
}
.wrapper .top .info .info-item .left {
  width: 0.7rem;
  margin-right: 0.06rem;
  color: #858585;
}
.wrapper .top .info .info-item .right {
  width: 2.84rem;
  color: #1f1f1f;
  word-wrap: break-word;
}
.wrapper .top .tip {
  display: block;
  width: calc(100% - 20px);
  margin: 0.1rem auto 0.2rem;
  background: #fff;
  border-radius: 0.12rem;
  font-size: 0.17rem;
  color: #1f1f1f;
  line-height: 0.17rem;
  padding-top: 0.15rem;
  padding-left: 13px;
  box-sizing: border-box;
}
.wrapper .top .tip-img {
  width: calc(100% + 13px);
  margin-left: -13px;
}

</style>
